import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  grade?: number;
  maxGrade: number;
  className?: string;
}

export const MaxGrade = ({ grade, maxGrade, className }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'mr-[10px] !w-fit rounded-full bg-[#DCF0FF] px-[12px] py-[4px] text-[12px] font-bold text-[#4383F2] lg:text-[16px]',
        className,
      )}
    >
      {grade ? t('currentGrade') : t('maximum amount of points')}: {grade ? `${grade}/${maxGrade}` : maxGrade}
    </div>
  );
};
